// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.historyToolbar[data-v-32c6a7e7]
	{
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 8px 14px;
		margin-bottom: 6px;
}
.loadingInline[data-v-32c6a7e7]
	{
		display: inline-flex;
		align-items: center;
		gap: 10px;
}
.mutedText[data-v-32c6a7e7]
	{
		color: #888888;
}
.small[data-v-32c6a7e7]
	{
		font-size: 0.85em;
}
.linkButton[data-v-32c6a7e7]
	{
		background: none;
		border: none;
		padding: 0;
		color: #1A5FB4;
		text-decoration: underline;
		cursor: pointer;
		font: inherit;
		font-size: 0.9em;
}
.linkButton[data-v-32c6a7e7]:disabled
		{
			color: #999999;
			cursor: default;
}
.errorBox[data-v-32c6a7e7]
	{
		background-color: #FFE0E0;
		border: 1px solid #C00000;
		color: #660000;
		padding: 8px 12px;
		white-space: pre-wrap;
}
.noteBox[data-v-32c6a7e7]
	{
		background-color: #F4F4F4;
		border: 1px solid #DDDDDD;
		color: #555555;
		padding: 8px 12px;
}
.tableScroll[data-v-32c6a7e7]
	{
		overflow-x: auto;
}
.historyTable[data-v-32c6a7e7]
	{
		border-collapse: collapse;
		width: 100%;
		font-size: 0.92em;
}
.historyTable th[data-v-32c6a7e7],
		.historyTable td[data-v-32c6a7e7]
		{
			text-align: left;
			padding: 5px 8px;
			border-bottom: 1px solid #E4E4E4;
			vertical-align: top;
}
.historyTable th[data-v-32c6a7e7]
		{
			color: #555555;
			font-size: 0.9em;
			white-space: nowrap;
}
.historyRow[data-v-32c6a7e7]
	{
		cursor: pointer;
}
.historyRow[data-v-32c6a7e7]:hover,
		.historyRow[data-v-32c6a7e7]:focus
		{
			background-color: #F4F7FB;
			outline: none;
}
.historyRow.selectedRow[data-v-32c6a7e7]
		{
			background-color: #DDEBFF;
}
.historyRow.attentionRow[data-v-32c6a7e7]
		{
			background-color: #FFF0F0;
}
.nowrap[data-v-32c6a7e7]
	{
		white-space: nowrap;
}
.summaryCell[data-v-32c6a7e7]
	{
		min-width: 200px;
		max-width: 420px;
		word-break: break-word;
}
code.inline[data-v-32c6a7e7]
	{
		font-family: Consolas, monospace;
		background-color: #F4F4F4;
		border-radius: 3px;
		padding: 0px 5px;
}
.stateBadge[data-v-32c6a7e7]
	{
		display: inline-block;
		padding: 2px 10px;
		border-radius: 10px;
		font-weight: bold;
		font-size: 0.9em;
		white-space: nowrap;
}
.badgeGood[data-v-32c6a7e7]
	{
		background-color: #D4F5D4;
		color: #0A5A0A;
		border: 1px solid #77CC77;
}
.badgeWarn[data-v-32c6a7e7]
	{
		background-color: #FFEFC9;
		color: #7A5200;
		border: 1px solid #E0B93F;
}
.badgeBad[data-v-32c6a7e7]
	{
		background-color: #FFE0E0;
		color: #8A0000;
		border: 1px solid #CC6666;
}
.badgeInfo[data-v-32c6a7e7]
	{
		background-color: #DDEBFF;
		color: #123F7A;
		border: 1px solid #7FAEE8;
}
.badgeHold[data-v-32c6a7e7]
	{
		background-color: #EADDFF;
		color: #3F1F7A;
		border: 1px solid #B39DE0;
}
.badgeOff[data-v-32c6a7e7]
	{
		background-color: #EEEEEE;
		color: #666666;
		border: 1px solid #CCCCCC;
}
.smallButton[data-v-32c6a7e7]
	{
		font-size: 0.9em;
		padding: 3px 10px;
}
.gradientButton[data-v-32c6a7e7]:disabled
	{
		opacity: 0.55;
		cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./www/vues/client/dbmaintenance/RunHistory.vue"],"names":[],"mappings":";AAuHC;;EAEC,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACnB;AAEA;;EAEC,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACV;AAEA;;EAEC,cAAc;AACf;AAEA;;EAEC,iBAAiB;AAClB;AAEA;;EAEC,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,gBAAgB;AACjB;AAEC;;GAEC,cAAc;GACd,eAAe;AAChB;AAED;;EAEC,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACtB;AAEA;;EAEC,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AAClB;AAEA;;EAEC,gBAAgB;AACjB;AAEA;;EAEC,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AAClB;AAEC;;;GAGC,gBAAgB;GAChB,gBAAgB;GAChB,gCAAgC;GAChC,mBAAmB;AACpB;AAEA;;GAEC,cAAc;GACd,gBAAgB;GAChB,mBAAmB;AACpB;AAED;;EAEC,eAAe;AAChB;AAEC;;;GAGC,yBAAyB;GACzB,aAAa;AACd;AAEA;;GAEC,yBAAyB;AAC1B;AAEA;;GAEC,yBAAyB;AAC1B;AAED;;EAEC,mBAAmB;AACpB;AAEA;;EAEC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACvB;AAEA;;EAEC,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AACjB;AAEA;;EAEC,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACpB;AAEA;;EAEC,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC1B;AAEA;;EAEC,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC1B;AAEA;;EAEC,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC1B;AAEA;;EAEC,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC1B;AAEA;;EAEC,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC1B;AAEA;;EAEC,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC1B;AAEA;;EAEC,gBAAgB;EAChB,iBAAiB;AAClB;AAEA;;EAEC,aAAa;EACb,mBAAmB;AACpB","sourcesContent":["<template>\n\t<div class=\"runHistory\">\n\t\t<div class=\"historyToolbar\">\n\t\t\t<span v-if=\"loading\" class=\"loadingInline\"><ScaleLoader /> Loading history…</span>\n\t\t\t<span v-else-if=\"runs.length\" class=\"mutedText\">{{runs.length}} most recent run{{runs.length === 1 ? '' : 's'}}, newest first.  Click a row to open it in the operation panel above.</span>\n\t\t\t<button type=\"button\" class=\"linkButton\" :disabled=\"loading || disabled\" @click=\"$emit('refresh')\">refresh</button>\n\t\t</div>\n\t\t<div v-if=\"error\" class=\"errorBox\">{{error}}</div>\n\t\t<div v-else-if=\"note\" class=\"noteBox\">{{note}}</div>\n\t\t<div v-else-if=\"!loading && !runs.length\" class=\"mutedText\">No maintenance runs have been recorded yet.</div>\n\t\t<div v-if=\"runs.length\" class=\"tableScroll\">\n\t\t\t<table class=\"historyTable\">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th>Started</th>\n\t\t\t\t\t\t<th>Operation</th>\n\t\t\t\t\t\t<th>Origin</th>\n\t\t\t\t\t\t<th>Actor</th>\n\t\t\t\t\t\t<th>Status</th>\n\t\t\t\t\t\t<th>Direction</th>\n\t\t\t\t\t\t<th>Databases</th>\n\t\t\t\t\t\t<th title=\"How long the web apps could not write: the source fence until every web server was running on the target\">Writes unavailable</th>\n\t\t\t\t\t\t<th title=\"Measured database cutover — the data-loss window (max over databases)\">DB cutover</th>\n\t\t\t\t\t\t<th title=\"Measured web-app cutover (database ONLINE → last web server healthy)\">Web cutover</th>\n\t\t\t\t\t\t<th>Summary</th>\n\t\t\t\t\t\t<th></th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr v-for=\"r in runs\" :key=\"r.runId\" class=\"historyRow\" :class=\"{ selectedRow: r.runId === selectedRunId, attentionRow: isAttention(r) && !r.acknowledged }\"\n\t\t\t\t\t\t:title=\"'Run ' + r.runId + ' — click to open'\" tabindex=\"0\" @click=\"$emit('select', r)\" @keydown.enter.prevent=\"$emit('select', r)\">\n\t\t\t\t\t\t<td class=\"nowrap\">\n\t\t\t\t\t\t\t{{formatDateTime(r.startedUtc)}}\n\t\t\t\t\t\t\t<div class=\"mutedText small\">{{formatElapsed(r.elapsedMs)}}<template v-if=\"!r.finishedUtc && isActive(r)\"> so far</template></div>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t{{runKindLabel(r.kind)}}\n\t\t\t\t\t\t\t<span v-if=\"r.dryRun\" class=\"stateBadge badgeOff\" title=\"Simulated in dry-run mode; nothing touched a live server.\">dry-run</span>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td>{{r.origin || '—'}}</td>\n\t\t\t\t\t\t<td>{{r.actor || '—'}}</td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<span class=\"stateBadge\" :class=\"runStatusBadgeClass(r.status)\">{{runStatusLabel(r.status)}}</span>\n\t\t\t\t\t\t\t<div v-if=\"r.acknowledged\" class=\"mutedText small\">acknowledged</div>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td class=\"nowrap\"><template v-if=\"r.sourceServer || r.targetServer\"><code class=\"inline\">{{r.sourceServer || '?'}}</code> → <code class=\"inline\">{{r.targetServer || '?'}}</code></template><template v-else>—</template></td>\n\t\t\t\t\t\t<td>{{r.dbNames && r.dbNames.length ? r.dbNames.join(', ') : '—'}}</td>\n\t\t\t\t\t\t<td class=\"nowrap\">{{formatMs(r.writesUnavailableMs)}}</td>\n\t\t\t\t\t\t<td class=\"nowrap\">{{formatSeconds(r.dbCutoverSeconds)}}</td>\n\t\t\t\t\t\t<td class=\"nowrap\">{{formatMs(r.webCutoverMs)}}</td>\n\t\t\t\t\t\t<td class=\"summaryCell\">{{r.summary || ''}}</td>\n\t\t\t\t\t\t<td class=\"nowrap\">\n\t\t\t\t\t\t\t<button v-if=\"r.hasReport\" type=\"button\" class=\"gradientButton lightBlue smallButton\" :disabled=\"disabled\" @click.stop=\"$emit('report', r)\">Report</button>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\t\t</div>\n\t</div>\n</template>\n\n<script>\n\t// History of previous maintenance runs (DbMaintenanceHistoryItem[]).  Emits `select(item)` when a row is clicked,\n\t// `report(item)` for the Report button and `refresh` for the refresh link.\n\timport { runKindLabel, runStatusLabel, runStatusBadgeClass, formatDateTime, formatElapsed, formatSeconds, formatMs, isActiveRunStatus, isAttentionRunStatus } from './runFormat';\n\n\texport default {\n\t\tprops:\n\t\t{\n\t\t\truns: {\n\t\t\t\ttype: Array,\n\t\t\t\tdefault: () => []\n\t\t\t},\n\t\t\tloading: {\n\t\t\t\ttype: Boolean,\n\t\t\t\tdefault: false\n\t\t\t},\n\t\t\t/** Grey informational note (e.g. the backend is not available yet). */\n\t\t\tnote: {\n\t\t\t\ttype: String,\n\t\t\t\tdefault: null\n\t\t\t},\n\t\t\terror: {\n\t\t\t\ttype: String,\n\t\t\t\tdefault: null\n\t\t\t},\n\t\t\t/** runId currently shown in the operation panel, highlighted in the table. */\n\t\t\tselectedRunId: {\n\t\t\t\ttype: String,\n\t\t\t\tdefault: null\n\t\t\t},\n\t\t\t/** Disables the buttons while an action or dialog is in flight. */\n\t\t\tdisabled: {\n\t\t\t\ttype: Boolean,\n\t\t\t\tdefault: false\n\t\t\t}\n\t\t},\n\t\tmethods:\n\t\t{\n\t\t\trunKindLabel,\n\t\t\trunStatusLabel,\n\t\t\trunStatusBadgeClass,\n\t\t\tformatDateTime,\n\t\t\tformatElapsed,\n\t\t\tformatSeconds,\n\t\t\tformatMs,\n\t\t\tisActive(r)\n\t\t\t{\n\t\t\t\treturn isActiveRunStatus(r.status);\n\t\t\t},\n\t\t\tisAttention(r)\n\t\t\t{\n\t\t\t\treturn isAttentionRunStatus(r.status);\n\t\t\t}\n\t\t}\n\t}\n</script>\n\n<style scoped>\n\t.historyToolbar\n\t{\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\talign-items: center;\n\t\tgap: 8px 14px;\n\t\tmargin-bottom: 6px;\n\t}\n\n\t.loadingInline\n\t{\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tgap: 10px;\n\t}\n\n\t.mutedText\n\t{\n\t\tcolor: #888888;\n\t}\n\n\t.small\n\t{\n\t\tfont-size: 0.85em;\n\t}\n\n\t.linkButton\n\t{\n\t\tbackground: none;\n\t\tborder: none;\n\t\tpadding: 0;\n\t\tcolor: #1A5FB4;\n\t\ttext-decoration: underline;\n\t\tcursor: pointer;\n\t\tfont: inherit;\n\t\tfont-size: 0.9em;\n\t}\n\n\t\t.linkButton:disabled\n\t\t{\n\t\t\tcolor: #999999;\n\t\t\tcursor: default;\n\t\t}\n\n\t.errorBox\n\t{\n\t\tbackground-color: #FFE0E0;\n\t\tborder: 1px solid #C00000;\n\t\tcolor: #660000;\n\t\tpadding: 8px 12px;\n\t\twhite-space: pre-wrap;\n\t}\n\n\t.noteBox\n\t{\n\t\tbackground-color: #F4F4F4;\n\t\tborder: 1px solid #DDDDDD;\n\t\tcolor: #555555;\n\t\tpadding: 8px 12px;\n\t}\n\n\t.tableScroll\n\t{\n\t\toverflow-x: auto;\n\t}\n\n\t.historyTable\n\t{\n\t\tborder-collapse: collapse;\n\t\twidth: 100%;\n\t\tfont-size: 0.92em;\n\t}\n\n\t\t.historyTable th,\n\t\t.historyTable td\n\t\t{\n\t\t\ttext-align: left;\n\t\t\tpadding: 5px 8px;\n\t\t\tborder-bottom: 1px solid #E4E4E4;\n\t\t\tvertical-align: top;\n\t\t}\n\n\t\t.historyTable th\n\t\t{\n\t\t\tcolor: #555555;\n\t\t\tfont-size: 0.9em;\n\t\t\twhite-space: nowrap;\n\t\t}\n\n\t.historyRow\n\t{\n\t\tcursor: pointer;\n\t}\n\n\t\t.historyRow:hover,\n\t\t.historyRow:focus\n\t\t{\n\t\t\tbackground-color: #F4F7FB;\n\t\t\toutline: none;\n\t\t}\n\n\t\t.historyRow.selectedRow\n\t\t{\n\t\t\tbackground-color: #DDEBFF;\n\t\t}\n\n\t\t.historyRow.attentionRow\n\t\t{\n\t\t\tbackground-color: #FFF0F0;\n\t\t}\n\n\t.nowrap\n\t{\n\t\twhite-space: nowrap;\n\t}\n\n\t.summaryCell\n\t{\n\t\tmin-width: 200px;\n\t\tmax-width: 420px;\n\t\tword-break: break-word;\n\t}\n\n\tcode.inline\n\t{\n\t\tfont-family: Consolas, monospace;\n\t\tbackground-color: #F4F4F4;\n\t\tborder-radius: 3px;\n\t\tpadding: 0px 5px;\n\t}\n\n\t.stateBadge\n\t{\n\t\tdisplay: inline-block;\n\t\tpadding: 2px 10px;\n\t\tborder-radius: 10px;\n\t\tfont-weight: bold;\n\t\tfont-size: 0.9em;\n\t\twhite-space: nowrap;\n\t}\n\n\t.badgeGood\n\t{\n\t\tbackground-color: #D4F5D4;\n\t\tcolor: #0A5A0A;\n\t\tborder: 1px solid #77CC77;\n\t}\n\n\t.badgeWarn\n\t{\n\t\tbackground-color: #FFEFC9;\n\t\tcolor: #7A5200;\n\t\tborder: 1px solid #E0B93F;\n\t}\n\n\t.badgeBad\n\t{\n\t\tbackground-color: #FFE0E0;\n\t\tcolor: #8A0000;\n\t\tborder: 1px solid #CC6666;\n\t}\n\n\t.badgeInfo\n\t{\n\t\tbackground-color: #DDEBFF;\n\t\tcolor: #123F7A;\n\t\tborder: 1px solid #7FAEE8;\n\t}\n\n\t.badgeHold\n\t{\n\t\tbackground-color: #EADDFF;\n\t\tcolor: #3F1F7A;\n\t\tborder: 1px solid #B39DE0;\n\t}\n\n\t.badgeOff\n\t{\n\t\tbackground-color: #EEEEEE;\n\t\tcolor: #666666;\n\t\tborder: 1px solid #CCCCCC;\n\t}\n\n\t.smallButton\n\t{\n\t\tfont-size: 0.9em;\n\t\tpadding: 3px 10px;\n\t}\n\n\t.gradientButton:disabled\n\t{\n\t\topacity: 0.55;\n\t\tcursor: not-allowed;\n\t}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
